<template>
    <div class="portfolio">
        <Title :title="'Visitas Guiadas'"></Title>
        <div class="row center-xs portfolio-line">
            <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
                <div class="row" v-if="guidedTours">
                    <div class="col-xs-12 col-md-6" v-for="guidedTour in guidedTours.items" :key="guidedTour.fields.title">
                        <GuidedTourCard v-on:card-selection="onSelectGuidedTour(guidedTour)" :entry="guidedTour" :image="getGuidedTourAsset(guidedTour.fields.cardImage.sys.id)"></GuidedTourCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "../generic/Title";
    import GuidedTourCard from "../cards/Card";

    export default {
        name: "GuidedTourList",
        components: {GuidedTourCard, Title},
        props: ['guidedTours'],
        methods: {
            getGuidedTourAsset(id) {
                return this.guidedTours.includes.Asset.find(asset => asset.sys.id === id);
            },
            onSelectGuidedTour(guidedTour) {
                this.$router.push(`/portfolio/${guidedTour.sys.id}`).catch(() => {});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .portfolio {
        margin-top: 3em;
        margin-bottom: 3em;
        background-color: $bgcolor;
        padding-bottom: 2em;
    }

    .separator {
        background-color: $primary;
        height: 0.4em;
        width: 2.4em;
        display: inline-block;
        margin-bottom: 0.8em;
    }

    .portfolio-title {
        margin-top: 2em;
        margin-bottom: 2em;
    }

    .portfolio-line {
        margin-top: 3em;

        .portfolio-card {
            margin-bottom: 1em;
            height: 20em;
            background-color: $bgcolor;
        }
    }

    .portfolio-know-more {
        margin-top: 3.5em;
        button {
            height: 3.5em;
            border: 0;
            width: 100%;
            background: $primary;
            color: $bgcolor-grey;
            text-transform: uppercase;
            font-size: x-small;
            letter-spacing: 0.1em;
            font-weight: 600;

            &:hover {
                background: $bgcolor-grey;
                color: $primary;
            }
        }

    }

</style>
